<template>
  <div class="more-container" @click="onMoreClick">
    <icon
      class="theme--light pointer more-container__icon"
      name="ellipsis-vertical" />
    <div v-show="showDropdown" class="more-container__dropdown more-dropdown">
      <div
        v-for="item in dropdownItems"
        :key="item.id"
        class="more-container__dropdown__item"
        @click="onItemClick(item)">
        {{ item.displayName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoreDropdown",
  props: {
    dropdownItems: {
      type: Array,
      default: () => [],
    },
    showDropdown: {
      type: Boolean,
      default: false,
    },
    onClickData: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    onMoreClick() {
      this.$emit("onClick", this.onClickData);
    },
    onItemClick(item) {
      this.$emit("onMoreOptionClick", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.more-container {
  &__icon {
    font-size: 28px;
  }
  &__dropdown {
    position: absolute;
    right: 8px;
    background: #fff;
    top: 2px;
    width: fit-content;
    border: 1px solid #e8eaec;
    box-shadow: 0px 1px 4px rgb(0 0 0 / 10%);
    &__item {
      padding: 6px 10px;
      border-bottom: 1px solid #e8eaec;
      cursor: pointer;
    }
  }
}
</style>
